import { SERVICES_CONFIG } from '../../constants';
import { useLanguage } from '../../hooks/useLanguage';
import '../../styles/components/Services.css';

const Services = () => {
  const { t } = useLanguage();

  const renderServiceCard = service => {
    const IconComponent = service.icon;
    const texts = t.services.items[service.id];

    return (
      <div key={service.id} className='service-card'>
        <div className='service-icon-wrapper'>
          <IconComponent size={32} className='service-icon' />
        </div>
        <h3 className='service-title'>{texts.title}</h3>
        <p className='service-description'>{texts.description}</p>
      </div>
    );
  };

  return (
    <section id='services' className='services section'>
      <div className='container'>
        <div className='services-header'>
          <h2 className='services-title'>{t.services.sectionTitle}</h2>
          <p className='services-subtitle'>{t.services.sectionSubtitle}</p>
        </div>

        <div className='services-grid'>
          {SERVICES_CONFIG.map(renderServiceCard)}
        </div>
      </div>
    </section>
  );
};

export default Services;
